<template>
  <div class="grupo">
    <!-- <h2>{{ titulo }}</h2> -->
    <div class="cards">
      <router-link
        v-for="(card, index) in cards"
        :key="index"
        :to="typeof card.rota === 'object' ? card.rota : { name: card.rota }"
      >
        <div class="texto">
          <img :src="card.icone" :class="card.iconeClasse" alt=" " />
          <h3 v-html="card.titulo"></h3>
          <p v-html="card.descricao"></p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "BuscaSimplesCards",
  props: {
    titulo: {
      type: String,
      required: true,
    },
    cards: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
/* Estilos mantidos iguais */
h2 {
  color: #2c3f2b;
  font-family: 'Poppins', sans-serif;
  font-size: 1.1rem;
  display: table;
  padding-right: 1rem;
  border-bottom: none; /* remove a linha sob o título */
  margin: 0rem 0rem 1rem 0.5rem;
}
.cards {
  display: grid;
  grid-template-columns: 1fr;
  padding: 0.5rem;
  overflow: auto;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
a {
  display: flex;
  flex-direction: column; /* Alterado para layout vertical */
  justify-content: center; /* Centraliza o conteúdo no card */
  align-items: center;
  text-decoration: none;
  background-color: transparent; /* sem fundo para os cards */
  // padding: 0.75rem 1rem; // sugestão de alterações para Nilton
  cursor: pointer;
  transition: 0.3s linear;
  text-align: center; /* Centraliza todo o texto */

  img {
    width: 4rem; /* Tamanho do ícone ajustado */
    display: block; /* evita espaço por baseline */
    margin-bottom: 0.05rem; /* micro-respiro entre imagem e título */
    transition: 0.3s ease-in-out;
  }

  .texto {
    margin-left: 0; /* Removido o espaçamento lateral */
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0; /* nenhum espaço extra entre img e h3 */
  }

  br {
    display: none;
  }

  h3 {
    text-transform: uppercase;
    font-size: 1.1rem;
    font-family: "Poppins-Bold";
    margin: 0rem;
    line-height: 1; /* compacta a altura da linha ao encostar na imagem */
    font-weight: 800;
    color: #2a5a9c; /* Cor alterada para azul */
  }

  p {
    color: #115810;
    font-size: 0.9rem;
    font-weight: 500;
    margin: 0.3rem 0rem 0rem 0rem; /* Adicionado um pequeno espaço acima */
  }
}

a:hover {
  background-color: transparent; /* mantém sem fundo no hover */
}
.alto-contraste {
  .cards {
    a {
      background-color: transparent; /* sem fundo também no alto contraste */
      h3 {
        color: #edf2ee;
      }
      p {
        color: #edf2ee;
      }
    }
  }
}

@media screen and (min-width: "25em") {
  .cards {
    grid-template-columns: 1fr 1fr;
    a {
      // padding-left: 1rem; // sugestão de alterações para Nilton
      padding-top: 0.5rem;
      img {
        width: 4rem;
        margin-bottom: 0.05rem;
      }
      h3 {
        font-size: 0.9rem;
        font-weight: bold;
      }
      p {
        font-size: 0.7rem;
      }
    }
  }
}
@media screen and (min-width: "64em") {
  .grupo {
    h2 {
      margin-left: 0rem;
      font-size: 1.3rem;
    }
  }
  .cards {
    a {
      img {
        width: 3.2rem;
        margin-bottom: 1rem;
      }
      h3 {
        font-size: 1.1rem;
        font-weight: bold;
      }
      p {
        font-size: 1rem;
      }
    }
    a:hover {
      img {
        //width: 5rem;
      }
    }
  }
}
@media screen and (min-width: "80em") {
  .grupo {
    h2 {
      margin-left: 0rem;
      font-size: 1.3rem;
    }
  }
  .cards {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    padding: 0rem;
    // margin-bottom: 2rem;
    a {
      p {
        font-size: 0.9rem;
      }
    }
  }
}
</style>
